<template>
    <VJoyBlockSkeleton class="profile-section-action__skeleton" circle height="40px" width="40px" />
</template>
<script setup lang="ts">
    import {VJoyBlockSkeleton} from '@maltjoy/core-vue';
</script>
<style lang="scss">
    .profile-section-action__skeleton {
        width: 40px !important;
        height: 40px;
    }
</style>
